import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { estimateDocTemplateEndpoints } from '@/lib/api/endpoints';
import { estimateDocTemplateKeys } from '@/lib/queryKeys';
import type { EstimateDocTemplate } from '@/types/estimateDocTemplate';

/** Fetches a single estimate document template (with its full layout). */
export function useEstimateDocTemplate(id: string) {
  return useApiQuery<EstimateDocTemplate>({
    queryKey: estimateDocTemplateKeys.detail(id),
    queryFn: () =>
      apiGet<EstimateDocTemplate>(operationsClient, estimateDocTemplateEndpoints.detail(id)),
    enabled: Boolean(id),
  });
}
